export default __webpack_public_path__ + "static/media/behavior_icon.c4697721.webp";